/* Zweifarbige Lackierung (live seit 07.10.2026): die zweite Farbe eines Kombi-Codes als Zusatz in der Auswahl.
   Markup und Daten aus snippets/ds-zweifarb.liquid. Ist ein Haken gesetzt, legt der normale Kaufknopf (und die
   feste Kaufleiste, die ihn klickt) beide Sets in einem Aufruf in den Warenkorb, je in der gewählten Menge.
   Preiszeile, Endpreis mit Versand und Kaufleiste rechnet ds-produkt.js über das Ereignis "ds:zusatz" nach.
   Wechselt die Ausführung (ds-produkt.js setzt data-handle an #ds-produkt), folgt der Partner. Dessen Set der
   anderen Ausführung kennt die Seite nur als Handle (Liquid löst je Seite höchstens 20 Produkte auf); Variante,
   Preis und Gewicht holt laden() dann aus /products/<handle>.js. */
(function () {
  var box = document.querySelector('[data-zweifarb]');
  var wurzel = document.getElementById('ds-produkt');
  if (!box || !wurzel) return;
  var daten;
  try { daten = JSON.parse(box.querySelector('[data-zweifarb-daten]').textContent); } catch (e) { return; }
  if (!daten.eigen || !daten.eigen.length) return;

  var formular = wurzel.querySelector('product-form');
  var form = formular && formular.querySelector('form');
  var knopf = form && form.querySelector('.dp-kaufen');
  var menge = wurzel.querySelector('.dp-menge-feld');
  var geldFormat = wurzel.dataset.geld || '{{amount_with_comma_separator}} €';

  // Preise stehen in Cent, Format wie in ds-produkt.js
  function geld(cent) {
    var v = Number(cent) / 100;
    var mitKomma = v.toFixed(2).replace('.', ',');
    return geldFormat
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, mitKomma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, mitKomma.replace(',00', ''))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, v.toFixed(0))
      .replace(/\{\{\s*amount\s*\}\}/, v.toFixed(2));
  }

  // Stelle der gewählten Ausführung: 0 Standard, 1 mit Grundierung (Reihenfolge wie in der Tabelle)
  // Kennt die Tabelle das Set der gewählten Ausführung nicht (der Shop führt ein anderes Grundierungs-Set), entscheidet der Name
  // der Ausführung, den ds-produkt.js als data-ausfuehrung an #ds-produkt setzt (Prüfbefund 07.10.2026)
  function stelle() {
    var h = wurzel.dataset.handle;
    for (var i = 0; i < daten.eigen.length; i++) if (daten.eigen[i].handle === h) return i;
    return /grundierung/i.test(wurzel.dataset.ausfuehrung || '') && daten.eigen.length > 1 ? 1 : 0;
  }
  // Set des Partners zur gewählten Ausführung; hat er keins mit Grundierung ("handle": null), das Standard-Set
  function partner(k) {
    var ps = daten.kombis[k].partner;
    var p = ps[stelle()];
    return p && p.handle ? p : ps[0];
  }
  function bereit(p) { return p.variante !== undefined; }

  // Fehlende Daten einmal je Handle holen; das Versprechen bleibt am Eintrag, damit Kauf und Anzeige darauf warten
  function laden(p) {
    if (bereit(p)) return Promise.resolve(p);
    if (!p.laeuft) {
      p.laeuft = fetch('/products/' + encodeURIComponent(p.handle) + '.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
        .then(function (prod) {
          var vs = prod.variants || [];
          var v = vs.filter(function (x) { return x.available; })[0] || vs[0] || {};
          p.variante = v.id || 0;
          p.preis = v.price || 0;
          p.gewicht = v.weight || 0;
          p.frei = !!v.available;
          return p;
        })
        .catch(function () { p.variante = 0; p.preis = 0; p.gewicht = 0; p.frei = false; return p; });
    }
    return p.laeuft;
  }
  function haken() { return [].slice.call(box.querySelectorAll('[data-zf-wahl]')); }
  function gewaehlt() { return haken().filter(function (c) { return c.checked && !c.disabled; }); }

  function zeichnen() {
    var offen = false;
    var s = stelle();
    haken().forEach(function (c) {
      var k = Number(c.dataset.kombi);
      var p = partner(k);
      var zeile = c.closest('.dp-zf-wahl');
      var ps = daten.kombis[k].partner;
      var ohne = zeile.querySelector('[data-zf-ohne]');
      if (ohne) ohne.hidden = !(s > 0 && !(ps[s] && ps[s].handle));
      // Der Name des Partners verlinkt sein Set in der gewaehlten Ausfuehrung (seit 21.10.2026)
      var link = zeile.querySelector('[data-zf-link]');
      if (link && p.handle) link.setAttribute('href', '/products/' + encodeURIComponent(p.handle));
      if (!bereit(p)) {
        // Haken bleibt, wie er ist; Preis kommt mit den Daten
        offen = true;
        laden(p).then(zeichnen);
        zeile.querySelector('[data-zf-preis]').textContent = '…';
        return;
      }
      var frei = !!(p.frei && p.variante);
      c.disabled = !frei;
      if (!frei) c.checked = false;
      zeile.classList.toggle('an', c.checked);
      zeile.querySelector('[data-zf-preis]').textContent = frei ? '+ ' + geld(p.preis) : 'nicht lieferbar';
    });
    if (offen) return;
    var wahl = gewaehlt();
    var preis = 0, gewicht = 0;
    wahl.forEach(function (c) { var p = partner(Number(c.dataset.kombi)); preis += p.preis; gewicht += p.gewicht; });
    // Der Kaufknopf behaelt "In den Warenkorb": "Beide in den Warenkorb" brach am Handy (390 px) in zwei Zeilen.
    // Dass beide Sets kommen, zeigen der Haken direkt darueber und die kleine Summe im Knopf ("Beide Farben · 33,80 €",
    // seit 21.10.2026 wie bei der Menge; ds-produkt.js). anzahl = gewaehlte Partner-Sets (mehrere Haken = mehrere Farben).
    wurzel.dispatchEvent(new CustomEvent('ds:zusatz', { detail: { preis: preis, gewicht: gewicht, anzahl: wahl.length } }));
  }

  box.addEventListener('change', function (e) { if (e.target.matches('[data-zf-wahl]')) zeichnen(); });

  // Ab vier Codes (seit 21.10.2026): erst nur die Code-Knoepfe; ein Tipp zeigt die Zeile(n) dieses Codes, ein zweiter Tipp
  // schliesst sie wieder. Zeilen, die zugehen, verlieren ihren Haken, damit nichts Unsichtbares in den Warenkorb kommt.
  var knoepfe = [].slice.call(box.querySelectorAll('[data-zf-code]'));
  knoepfe.forEach(function (b) {
    b.addEventListener('click', function () {
      var an = b.getAttribute('aria-pressed') !== 'true';
      knoepfe.forEach(function (x) { x.setAttribute('aria-pressed', x === b && an ? 'true' : 'false'); });
      [].forEach.call(box.querySelectorAll('.dp-zf-wahl[data-code]'), function (z) {
        var zeigen = an && z.dataset.code === b.dataset.zfCode;
        z.classList.toggle('zeigen', zeigen);
        var c = z.querySelector('[data-zf-wahl]');
        if (!zeigen && c && c.checked) c.checked = false;
      });
      zeichnen();
    });
  });
  if (window.MutationObserver) {
    new MutationObserver(zeichnen).observe(wurzel, { attributes: true, attributeFilter: ['data-handle'] });
  }

  function fehlerZeigen(text) {
    var huelle = formular.querySelector('.product-form__error-message-wrapper');
    if (!huelle) return;
    huelle.querySelector('.product-form__error-message').textContent = text || '';
    huelle.hidden = !text;
  }

  // Mit Haken: beide Varianten in einem Aufruf. Der Lauscher sitzt in der Capture-Phase am <product-form>, läuft
  // also vor Dawns Lauscher am Formular und hält ihn an. Ohne Haken bleibt alles bei Dawn.
  if (formular && form) formular.addEventListener('submit', function (ev) {
    var wahl = gewaehlt();
    if (!wahl.length) return;
    ev.preventDefault();
    ev.stopPropagation();
    if (knopf.getAttribute('aria-disabled') === 'true') return;
    var n = Math.max(1, parseInt(menge && menge.value, 10) || 1);
    var eigen = Number(form.querySelector('input[name="id"]').value);
    var drawer = document.querySelector('cart-drawer');
    var body = {};
    if (drawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
      if (drawer.setActiveElement) drawer.setActiveElement(document.activeElement);
    }
    fehlerZeigen('');
    knopf.setAttribute('aria-disabled', 'true');
    knopf.classList.add('loading');
    var kreisel = knopf.querySelector('.loading__spinner');
    if (kreisel) kreisel.classList.remove('hidden');
    Promise.all(wahl.map(function (c) { return laden(partner(Number(c.dataset.kombi))); }))
      .then(function (ps) {
        if (ps.some(function (p) { return !(p.frei && p.variante); })) {
          zeichnen();
          throw new Error('Die zweite Farbe ist gerade nicht lieferbar. Bitte prüfen Sie die Auswahl.');
        }
        body.items = [{ id: eigen, quantity: n }].concat(ps.map(function (p) { return { id: p.variante, quantity: n }; }));
        return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body)
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) throw new Error(res.description || res.message || '');
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'zweifarb', cartData: res });
        }
        if (drawer && drawer.renderContents) {
          drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        } else {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
        }
      })
      .catch(function (e) {
        fehlerZeigen((e && e.message) || 'Das hat nicht geklappt. Bitte legen Sie die Sets einzeln in den Warenkorb.');
      })
      .then(function () {
        knopf.classList.remove('loading');
        knopf.removeAttribute('aria-disabled');
        if (kreisel) kreisel.classList.add('hidden');
      });
  }, true);

  zeichnen();
  // ds-produkt.js lädt async und kann seinen Lauscher für "ds:zusatz" erst nach diesem Skript setzen; ein vom Browser
  // wiederhergestellter Haken ginge sonst in der Preiszeile verloren (Prüfbefund 07.10.2026). Nach "load" liefen beide.
  window.addEventListener('load', zeichnen);
  window.addEventListener('pageshow', function (e) { if (e.persisted) zeichnen(); });
})();
